import React from 'react';
import {GoogleMap, LoadScript, Marker} from '@react-google-maps/api';
import GooglePlacesAutocomplete from "react-google-places-autocomplete";


const containerStyle = {
    width: '100%',
    height: '400px'
};

const center = {
    lat: 5.359952,
    lng: -4.008256
};

export default function GoogleMapsComponent(props){

    const {onPositionChoosed, onMarkerClicked, location,lat,lng, markers} = props;

    const [marker,setMarker] = React.useState({lat: lat,lng: lng});

    const markerRefs = React.useRef({});

    React.useEffect(()=>{
        setMarker({lat:parseFloat(lat),lng:parseFloat(lng)})
    },[lat,lng]);

    function onMapsClicked(event){

        if(location)
            return;

        console.log(event);

        const lat = event.latLng.lat();
        const lng = event.latLng.lng();

        setMarker({
            lat,lng
        })

        if(onPositionChoosed)
            onPositionChoosed({
                lat,lng
            })

    }

    React.useEffect(()=>{

        console.log(markerRefs);

        Object.values(
            markerRefs.current
        ).map(
            marker => {
                // marker.setMap(null)
            }
        )

        markerRefs.current = {};

    },[markers]);


    return (
        <div>

            <LoadScript
                googleMapsApiKey="AIzaSyBJzgyR3Un04ndSCrm3Ac1goqPxd5U_HQw"
            >
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={center}
                    zoom={12}
                    onClick={onMapsClicked}
                >

                    {
                        markers &&  markers.map(
                            (marker, index) => {
                                return <Marker
                                    ref={(ref) => {
                                        markerRefs.current[marker.key] = ref
                                    }}
                                    key={marker.key}
                                        onClick={()=>{
                                            if(onMarkerClicked)
                                                onMarkerClicked(marker)
                                        }}
                                    position={marker} />
                            }
                        )
                    }

                </GoogleMap>
            </LoadScript>
        </div>
    );
}